import React, { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import SpinnerButton from "@/components/SpinnerButton";
import { adminApi } from "@/lib/api";

export default function AdminOffDays() {
  const [rows, setRows] = useState([]);
  const [date, setDate] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const load = async () => {
    const r = await adminApi.offdays();
    setRows(r.data.off_days);
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    setErr("");
    if (!date) { setErr("Date is required."); return; }
    setLoading(true);
    try { await adminApi.offdayCreate({ date, reason }); setDate(""); setReason(""); load(); }
    catch (e) { setErr(e?.response?.data?.detail || "Failed."); }
    finally { setLoading(false); }
  };

  return (
    <AdminLayout>
      <p className="scw-eyebrow" style={{ marginBottom: 8 }}>Closures</p>
      <h1 style={{ fontSize: 28, margin: "0 0 28px 0" }}>Off days</h1>
      <p style={{ color: "var(--scw-muted)", fontSize: 13, marginBottom: 24 }}>Sundays are automatically unavailable regardless of this list.</p>

      <div className="scw-card" style={{ marginBottom: 24 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr auto", gap: 16, alignItems: "end" }}>
          <div>
            <label className="scw-label">Date</label>
            <input type="date" className="scw-input" value={date} onChange={(e) => setDate(e.target.value)} data-testid="offdays-date-input" />
          </div>
          <div>
            <label className="scw-label">Reason</label>
            <input className="scw-input" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="e.g. Public holiday" data-testid="offdays-reason-input" />
          </div>
          <SpinnerButton loading={loading} type="button" onClick={add} dataTestId="offdays-add-btn">Add</SpinnerButton>
        </div>
        {err && <p style={{ color: "#a13b3b", fontSize: 13, marginTop: 12 }}>{err}</p>}
      </div>

      <div className="scw-card" style={{ padding: 0 }}>
        {rows.length === 0 ? (
          <p style={{ padding: 24, color: "var(--scw-muted)" }}>No off days set.</p>
        ) : (
          <table className="scw-table">
            <thead><tr><th>Date</th><th>Reason</th><th></th></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.Date} data-testid={`offdays-row-${r.Date}`}>
                  <td>{r.Date}</td>
                  <td>{r.Reason || "\u2014"}</td>
                  <td style={{ textAlign: "right" }}>
                    <button className="scw-btn scw-btn-ghost" style={{ padding: "6px 12px" }}
                            onClick={async () => { await adminApi.offdayDelete(r.Date); load(); }}
                            data-testid={`offdays-delete-${r.Date}`}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </AdminLayout>
  );
}
